<div class="container-fluid maap-root-container">
    <app-header></app-header>
    <div class="risk-scoring-page-content">
        <header class="standalone-page-header px-3">
            <h1 class="standalone-page-title">Risk Scoring</h1>
        </header>
        <router-outlet></router-outlet>
        <div class="row">
        <p-toast position="top-center" life="10000"></p-toast>
        <div class="col-12 text-right">
            <button label="Add Risk Scoring" (click)="showConfigAdd()" class="mr-2 mb-2 btn btn-sm btn-light">Add Risk Scoring</button>
        </div>
        <div class="col-12">
            <p-table [value]="records" [lazy]="true" (onLazyLoad)="loadRecordsLazy($event)" [paginator]="true" [rows]="20" [totalRecords]="totalCount">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of cols">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="cols">
                    <tr>
                        <td *ngFor="let col of cols">
                            <ng-container *ngIf="col.header !== 'Actions';else actions">
                                {{rowData[col.field]}}
                            </ng-container>
                            <ng-template #actions>
                                <button class="btn btn-sm btn-light" (click)="showUpdateriskScoring(rowData)">Edit</button>
                                <button class="btn btn-sm btn-light ml-3" (click)="deleteriskScoring(rowData)">Delete</button>
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        </div>
    </div>
</div>

<p-dialog header="Create Risk Scoring" [(visible)]="riskScoringAddUpdate" [style]="{width: '50vw'}">
    <div class="ui-config">
        <div class="row">
            <div class="col-12 text-right">
                <button class="btn btn-sm btn-primary ml-3" (click)="addCondition()">Add Condition</button><br/>
                <small id="emailHelp" class="form-text text-muted ml-3">click above icon to add more conditions.</small>
            </div>
            <!-- <div class="information ml-3">
                <small id="emailHelp" class="form-text text-muted ml-3">click above icon to add more conditions.</small>
            </div> -->
            <div class="col-md-12">
                <div class="form-group mt-3" *ngFor="let condition of scope.condition; let i = index;">
                    <div class="row" *ngIf="i%2===0">
                        <div class="col-12">
                            <label class="col-md-2" style="display:block;">Condition</label>
                        </div>
                    <!-- <th width="150px"><button type="button" (click)="addQuantity()" class="btn btn-primary">Add More</button></th> -->
                    
                        <div class="col-4">
                            <input class="form-control" type="text" [(ngModel)]="scope.condition[i]" (change)="validateForm()" (keyup)="validateForm()" #name="ngModel" name="condition{{i}}" />
                            <small id="emailHelp" class="form-text text-muted">Please enter condition symbol</small>
                        </div>
                        <div class="col-4">
                            <input class="form-control" type="number" [(ngModel)]="scope.condition[i+1]" (change)="validateForm()" (keyup)="validateForm()" #name="ngModel" name="condition{{i}}" />
                            <small id="emailHelp" class="form-text text-muted">Please enter number</small>
                        </div>
                        <div class="col-2">
                            <button type="button" class="btn btn-sm btn-danger" (click)="removeCondition(i)">Remove</button>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select 
                            [options]="icon_types" 
                            [(ngModel)]="scope.icon" 
                            (onChange)="validateForm()" 
                            (onKeyup)="validateForm()"
                            [styleClass]="'w-100'">
                        </p-select>
                        <label for="icon">Icon</label>
                    </p-floatlabel>
                    <small id="emailHelp" class="form-text text-muted">Please enter color of icon</small>
                </div>
            </div>
            <!-- <div class="col-md-12">
                <label style="display:block;">Service Group</label>
                <app-service-grp-select (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
            </div> -->
            <div class="col-md-6">
                <div class="form-group">
                    <label style="display:block;">Region</label>
                    <div class="form-group">
                        <select [(ngModel)]="scope.regionId" name="regionId" class="form-control" (change)="onRegionChanged()">
                          <option *ngFor="let region of regionOptions" [value]="region.id">{{region.label}}</option>
                        </select>
                        <small id="emailHelp" class="form-text text-muted">Please select region</small>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select 
                            [options]="crieteria_types" 
                            [(ngModel)]="scope.criteria" 
                            (onChange)="checkCrieteria()"
                            [styleClass]="'w-100'">
                        </p-select>
                        <label for="criteria">Crieteria</label>
                    </p-floatlabel>
                    <small id="emailHelp" class="form-text text-muted">Please select crieteria</small>
                </div>
            </div>
            <div class="col-md-6" *ngIf="this.showCampus === true">
                <div class="form-group">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select 
                            [(ngModel)]="scope.campusId" 
                            [options]="campusOptions"
                            [styleClass]="'w-100'">
                        </p-select>
                        <label for="campus">Campus</label>
                    </p-floatlabel>
                    <small id="emailHelp" class="form-text text-muted">Please select campus</small>
                </div>
            </div>
        </div>
        <p-footer>
            <div class="form-group float-right mt-3">
                <button class="btn btn-sm btn-light ml-3" (click)="this.riskScoringAddUpdate=false" type="submit ">Cancel</button>
                <button class="btn btn-sm btn-light ml-3 mr-3" [disabled]="!isValid" (click)=" submitriskScoring() " (click)="this.riskScoringAddUpdate=false " type="submit "> Submit</button>
            </div>
        </p-footer>
    </div>
</p-dialog>
